import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom:20px;

`;
export const StyledSpanTitle = styled(Styled.H1)``;

export const StyledSpanTitleMiddle = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 1;
  &:after {
    position: absolute;
    display: block;
    content: "";
    width: 490px;
    height: 5px;
    background: ${EColors.primary_200};
    position: absolute;
    bottom: -3px;
    left: 0;
    z-index: 0;
  }
  @media screen and (max-width: 767px) {
    &:after {
      position: absolute;
      display: block;
      content: "";
      width: 319px;
      height: 5px;
      background: ${EColors.primary_200};
      position: absolute;
      bottom: -3px;
      left: 0;
      z-index: 1;
    }
  }
`;
export const StyledSpan = styled(StyledSpanTitle)`
z-index: 1;
`;
export const IconLogo = styled.img`
  width: 41px;
  height: 50px;
  @media screen and (max-width: 767px) {
    width: 27px;
    height: 33px;
  }
`;
